import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthGuard"] */ "/workspace/src/components/auth/auth-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/workspace/src/components/icons/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/layout/header.tsx");
